import React, { Fragment, useEffect, useState } from "react";
import Select from "react-select";
import AsyncSelect from 'react-select/async';
import { getArtists, getComposers } from "../../../actions/user";
import remove_icon from "../../../assets/images/icon-remove.svg";
import { DefaultButton } from "../../widgets";
import "../../../assets/scss/components/track/searchTrack.scss";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../../types/models/store";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../hooks/useAuth";

interface artistOption {
  value: number;
  label: string;
};

export type { artistOption };

export const SearchTrack: React.FC<any> = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { track_filter } = useSelector((state: StoreState) => state.auth);
  const { user } = useAuth() as any;
  const {
    loading = false,
    handleSearch,
    handleReset,
    genreList = [],
    tempoList = [],
    moodList = [],
    filtered_composer_list,
    filtered_artist_list,
    genreCount,
    moodCount,
    tempoCount,
    title = "",
  } = props.data;

  const [totalArtistCount, setTotalArtistCount] = useState(0);
  const [totalComposerCount, setTotalComposerCount] = useState(0);
  const [artistCount, setArtistCount] = useState(0);
  const [composerCount, setComposerCount] = useState(0);
  const [isMySong, setIsMySong] = useState(false);

  useEffect(() => {
    getArtists("").then((data) => {
      setTotalArtistCount(data.result.total);
    });
    getComposers("").then((data) => {
      setTotalComposerCount(data.result.total);
    });

    const params = new URLSearchParams(window.location.search);
    let isMySong = params.get("mysong") === "true";
    setIsMySong(isMySong);
    dispatch({
      type: "SET_TRACK_FILTER",
      payload: {
        ...track_filter,
        isMyPage: isMySong,
      },
    });
  }, []);

  const handleGenre = (genre: any) => {
    let list: any[] = [];
    track_filter.genre.forEach((g: any) => {
      if (genre !== g) list.push(g);
    });
    if (!track_filter.genre.filter((g: any) => g === genre).length) {
      list.push(genre);
    }
    dispatch({
      type: "SET_TRACK_FILTER",
      payload: {
        ...track_filter,
        genre: list,
      },
    });
  };

  const handleMood = (mood: number) => {
    if (loading !== "") return;
    let list = [];
    track_filter.mood.forEach((g: any) => {
      if (mood !== g) list.push(g);
    });
    if (!track_filter.mood.filter((g: any) => g === mood).length) {
      list.push(mood);
    }
    dispatch({
      type: "SET_TRACK_FILTER",
      payload: {
        ...track_filter,
        mood: list,
      },
    });
  };

  const handleArtist = (artist: any) => {
    if (loading !== "") return;
    let list = [];
    track_filter.artist.forEach((g: any) => {
      if (artist.id !== g.id) list.push(g);
    });
    if (!track_filter.artist.filter((g: any) => g.id === artist.id).length) {
      list.push(artist);
    }
    dispatch({
      type: "SET_TRACK_FILTER",
      payload: {
        ...track_filter,
        artist: list,
      },
    });
  };

  const handleComposer = (composer: any) => {
    if (loading !== "") return;
    let list = [];
    track_filter.composer.forEach((g: any) => {
      if (composer.id !== g.id) list.push(g);
    });
    if (!track_filter.composer.filter((g: any) => g.id === composer.id).length) {
      list.push(composer);
    }
    dispatch({
      type: "SET_TRACK_FILTER",
      payload: {
        ...track_filter,
        composer: list,
      },
    });
  };

  const handleTempo = (tempo: any) => {
    if (loading !== "") return;
    let list = [];
    track_filter.tempo.forEach((g: any) => {
      if (tempo !== g) list.push(g);
    });
    if (!track_filter.tempo.filter((g: any) => g === tempo).length) {
      list.push(tempo);
    }
    dispatch({
      type: "SET_TRACK_FILTER",
      payload: {
        ...track_filter,
        tempo: list,
      },
    });
  };

  const filterArtistList = async (inputValue: string) => {
    try {
      let res = await getArtists(inputValue);
      setArtistCount(res.result.total);
      return res.result.list?.map((item: any) => ({
        value: item.id,
        label: item.name
      }));
    } catch (error) {
      console.error("Error fetching artists:", error);
      return [];
    }
  };

  const loadArtistList = (
    inputValue: string,
    callback: (options: artistOption[]) => void
  ) => {
    setTimeout(async () => {
      callback(await filterArtistList(inputValue));
    }, 500);
  };

  const filterComposerList = async (inputValue: string) => {
    let res = await getComposers(inputValue).then((data) => {
      setComposerCount(data.result.total);
      return data.result.list?.map((item: any) => ({
        value: item.id,
        label: item.name
      }));
    });
    return res;
  };

  const loadComposerList = (
    inputValue: string,
    callback: (options: artistOption[]) => void
  ) => {
    setTimeout(async () => {
      callback(await filterComposerList(inputValue));
    }, 500);
  };

  const handleMySong = () => {
    if (loading !== "") return;
    const params = new URLSearchParams(window.location.search);
    let isMySong = params.get("mysong") === "true";
    if (isMySong) {
      params.delete("mysong");
    } else
      params.set("mysong", "true");
    setIsMySong(!isMySong);
    dispatch({
      type: "SET_TRACK_FILTER",
      payload: {
        ...track_filter,
        isMyPage: !isMySong,
      },
    });
    navigate(`/all-tracks?${params.toString()}`);
  };

  return (
    <Fragment>
      <div className="search-component">
        <div className="container uk-container-large">
          {title !== '' ? (
            <div className="label title-label fw-bold mb-4">
              {title}
              {/* Which song are you looking for? */}
            </div>
          ) : (<></>)}
          <div className="search-content row d-flex flex-row position-relative justify-content-between mt-3">
            {/* <div className="col-md-2 search-item">
              <div className="item-header">
                <div className="text-white item-title">Name</div>
                <div className="count-found">found {clientList.length}</div>
              </div>
              <div
                className="d-flex flex-row justify-content-between align-items-center"
                style={{ width: "100%" }}
              >
                <Select
                  className="select-search"
                  options={
                    clientList?.map((item: any) => ({
                      value: item.id,
                      label: item.title
                    }))
                  }
                  onChange={(item: any) =>
                    {
                      if(+item.value===2){
                        // handleClient(+item.value)
                      }else{
                        alert("Please contact Cugate Ltd. for access permissions.");
                      }
                    }
                  }
                  placeholder=""
                  isSearchable={true}
                />
              </div>
              <div className="d-flex flex-row flex-wrap mt-2">
                {client?.map((item: any) => (
                  <div
                    className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                    key={"client_" + item}
                    // onClick={() => handleClient(item)}
                  >
                    <div className="me-2 title">{clientList.filter((c: any) => c.id === item).length ? clientList.filter((c: any) => c.id === item)[0].title : ''}</div>
                    {/ <img
                      alt="remove"
                      className="remove-selected"
                      src={remove_icon}
                    /> /}
                  </div>
                ))}
              </div>
            </div> */}
            <div className="col-md-2 search-item">
              <div className="item-header">
                <div className="text-white item-title">Artist</div>
                <div className="count-found">found {
                  (filtered_artist_list === -1 || filtered_artist_list?.length === 0) ? artistCount : filtered_artist_list.length
                } of {totalArtistCount}</div>
              </div>
              <div
                className="d-flex flex-row justify-content-between align-items-center"
                style={{ width: "100%" }}
              >
                {(filtered_artist_list === -1 || filtered_artist_list?.length === 0) ? (
                  <AsyncSelect
                    cacheOptions
                    className="select-search"
                    placeholder=""
                    loadOptions={loadArtistList}
                    defaultOptions
                    onChange={(item: any) => {
                      handleArtist({
                        id: +item.value,
                        name: item.label
                      })
                      setArtistCount(totalArtistCount);
                    }
                    }
                    onBlur={() => {
                      setArtistCount(totalArtistCount);
                    }}
                    blurInputOnSelect={false}
                    isSearchable={true}
                  />
                ) : (
                  <Select
                    className="select-search"
                    options={
                      filtered_artist_list?.map((item: any) => ({
                        value: +item.id,
                        label: item.name
                      }))
                    }
                    onChange={(item: any) =>
                      handleArtist({
                        id: +item.value,
                        name: item.label
                      })
                    }
                    placeholder=""
                    isSearchable={true}
                  />
                )}
              </div>
              <div className="d-flex flex-row flex-wrap mt-2">
                {Array.isArray(filtered_artist_list) && track_filter.artist?.map((item: any) => (
                  <div
                    className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                    key={"artist_" + item.id}
                    onClick={() => handleArtist(item)}
                  >
                    <div className="me-2 title">{item.name}</div>
                    <img
                      alt="remove"
                      className="remove-selected"
                      src={remove_icon}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-2 search-item">
              <div className="item-header">
                <div className="text-white item-title">Composer</div>
                <div className="count-found">found {
                  (filtered_composer_list === -1 || filtered_composer_list?.length === 0) ? composerCount : filtered_composer_list.length
                } of {totalComposerCount}</div>
              </div>
              <div
                className="d-flex flex-row justify-content-between align-items-center"
                style={{ width: "100%" }}
              >
                {(filtered_composer_list === -1 || filtered_composer_list?.length === 0) ? (
                  <AsyncSelect
                    cacheOptions
                    className="select-search"
                    placeholder=""
                    loadOptions={loadComposerList}
                    defaultOptions
                    onChange={(item: any) => {
                      setComposerCount(totalComposerCount);
                      handleComposer({
                        id: +item.value,
                        name: item.label
                      });
                    }
                    }
                    onBlur={() => {
                      setComposerCount(totalComposerCount);
                    }}
                    blurInputOnSelect={false}
                    isSearchable={true}
                  />
                ) : (
                  <Select
                    className="select-search"
                    options={
                      filtered_composer_list?.map((item: any) => ({
                        value: item.id,
                        label: item.name
                      }))
                    }
                    onChange={(item: any) =>
                      handleComposer({
                        id: +item.value,
                        name: item.label
                      })
                    }
                    placeholder=""
                    isSearchable={true}
                  />
                )}
              </div>
              <div className="d-flex flex-row flex-wrap mt-2">
                {Array.isArray(filtered_composer_list) && track_filter.composer?.map((item: any) => (
                  <div
                    className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                    key={"composer_" + item.id}
                    onClick={() => handleComposer(item)}
                  >
                    <div className="me-2 title">{item.name}</div>
                    <img
                      alt="remove"
                      className="remove-selected"
                      src={remove_icon}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-2 search-item">
              <div className="item-header">
                <div className="text-white item-title">Tempo</div>
                <div className="count-found">found {tempoList.length} of {tempoCount}</div>
              </div>
              <div
                className="d-flex flex-row justify-content-between align-items-center"
                style={{ width: "100%" }}
              >
                <Select
                  className="select-search"
                  options={
                    tempoList?.map((item: any) => ({
                      value: item.id,
                      label: item.title
                    }))
                  }
                  onChange={(item: any) =>
                    handleTempo(+item.value)
                  }
                  placeholder=""
                  isSearchable={true}
                />
              </div>
              <div className="d-flex flex-row flex-wrap mt-2">
                {track_filter.tempo?.map((item: any) => (
                  <div
                    className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                    key={"composer_" + item}
                    onClick={() => handleTempo(item)}
                  >
                    <div className="me-2 title">{tempoList.find((g: any) => g.id === item)?.title}</div>
                    <img
                      alt="remove"
                      className="remove-selected"
                      src={remove_icon}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-2 search-item">
              <div className="item-header">
                <div className="text-white item-title">Genre</div>
                <div className="count-found">found {genreList.length} of {genreCount}</div>
              </div>
              <div
                className="d-flex flex-row justify-content-between align-items-center"
                style={{ width: "100%" }}
              >
                <Select
                  className="select-search"
                  options={genreList?.map((item: any) => ({
                    value: item.id,
                    label: item.title
                  }))}
                  placeholder=""
                  onChange={(item: any) =>
                    handleGenre(+item.value)
                  }
                  isSearchable={true}
                />
              </div>
              <div className="d-flex flex-row flex-wrap mt-2">
                {track_filter.genre?.map((item: any) => (
                  <div
                    className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                    key={"genre_" + item}
                    onClick={() => handleGenre(item)}
                  >
                    <div className="me-2 title">
                      {genreList.find((g: any) => g.id === item)?.title}
                    </div>
                    <img
                      alt="remove"
                      className="remove-selected"
                      src={remove_icon}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="col-md-2 search-item">
              <div className="item-header">
                <div className="text-white item-title">Mood</div>
                <div className="count-found">found {moodList.length} of {moodCount}</div>
              </div>
              <div
                className="d-flex flex-row justify-content-between align-items-center"
                style={{ width: "100%" }}
              >
                <Select
                  className="select-search"
                  options={moodList?.map((item: any) => ({
                    value: item.id,
                    label: item.title
                  }))}
                  placeholder=""
                  onChange={(item: any) => handleMood(+item.value)}
                  isSearchable={true}
                />
              </div>
              <div className="d-flex flex-row flex-wrap mt-2">
                {track_filter.mood?.map((item: any) => (
                  <div
                    className="d-flex flex-row align-items-center me-4 mb-1 selected-search"
                    key={"mood_" + item}
                    onClick={() => handleMood(item)}
                  >
                    <div className="me-2 title">
                      {moodList.find((m: any) => m.id === item)?.title}
                    </div>
                    <img
                      alt="remove"
                      className="remove-selected"
                      src={remove_icon}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between button-bar">
            <div className="tab-header"></div>
            <div className="d-flex justify-content-end">
              <div
                className={
                  "d-flex justify-content-end align-items-center focus me-4" + (
                    user?.counters?.track ? "" : " d-none"
                  )}
                // onClick={()=>navigate('/analyse-uploads')}
                onClick={() => handleMySong()}
              >
                <div
                  className={"fs-6 btn-reset-filter me-2"}
                  style={{ color: isMySong ? 'var(--color-blue-light)' : 'var(--color-blue-light-bg)' }}
                >
                  My songs
                </div>
                {isMySong && (
                  <img
                    alt="remove"
                    className="remove-selected"
                    src={remove_icon}
                  />
                )}
              </div>
              <div className={"d-flex justify-content-end align-items-center me-4" + (
                track_filter?.genre?.length + track_filter?.mood.length + track_filter?.artist?.length + track_filter?.composer?.length || track_filter?.keyword !== "" ? "" : " d-none"
              )}>
                <div
                  className="text-decoration-underline fs-6 btn-reset-filter"
                  onClick={handleReset}
                >
                  Reset filter
                </div>
              </div>
              <div className="d-flex flex-row justify-content-between align-items-center py-1">
                <DefaultButton
                  className="middle-button"
                  color="#ffcc00"
                  textColor="var(--color-primary)"
                  borderColor="#ffcc00"
                  onClick={() => {
                    handleSearch();
                  }}
                >
                  Search
                </DefaultButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default SearchTrack;
